import ScqDiagramCourseController from '../../../scq-diagram-course.controller';

class Diagram2Controller extends ScqDiagramCourseController {

  constructor(courseService, diagramService, $translate, $timeout) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout);
  }

}

export default Diagram2Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram2/diagram2.controller.js